export interface SalesRep {
  slug: 'patrick' | 'andrew' | 'nadia';
  name: string;
  initials: string;
  email: string;
  emailAliases?: readonly string[];
}

export const SALES_REPS: readonly SalesRep[] = [
  { slug: 'patrick', name: 'Patrick Dalvinck', initials: 'PD', email: 'patrick.dalvinck@sequesto.com' },
  { slug: 'andrew',  name: 'Andrew Cherkas',   initials: 'AC', email: 'andrew.cherkas@sequesto.com' },
  {
    slug: 'nadia',
    name: 'Nadia Rexhepi',
    initials: 'NR',
    email: 'nadia.rexhepi@sequesto.com',
    emailAliases: ['naxhie.rexhepi@sequesto.com'],
  },
] as const;

export type SalesRepSlug = SalesRep['slug'];

export function getRep(slug: SalesRepSlug): SalesRep {
  const rep = SALES_REPS.find((r) => r.slug === slug);
  if (!rep) throw new Error(`Unknown rep: ${slug}`);
  return rep;
}

export function getRepByEmail(email: string): SalesRep | undefined {
  const lower = email.toLowerCase();
  return SALES_REPS.find(
    (r) => r.email.toLowerCase() === lower
      || r.emailAliases?.some((a) => a.toLowerCase() === lower),
  );
}
